import { render, staticRenderFns } from "./OptionsParcels.vue?vue&type=template&id=67f9f62d&"
import script from "./OptionsParcels.vue?vue&type=script&lang=js&"
export * from "./OptionsParcels.vue?vue&type=script&lang=js&"
import style0 from "./OptionsParcels.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VContainer,VListItemContent,VListItemTitle,VSelect})
